import { Box, Skeleton } from '@mui/material';

import PageContent from '@root/components/v2/layout/PageContent';
import PageHeaderSkeleton from '@root/components/v2/layout/PageHeader/Skeleton';
import { useTheme } from '@root/context/ThemeContext';

/**
 * Placeholder for the Explorer tab's graph canvas: the floating search / filter controls that sit on
 * top of the canvas, plus the canvas itself.
 *
 * @param contentOnly render just the body, without the PageContent wrapper and header skeleton —
 * used as the Suspense fallback for a tab switch inside the Inventory shell, which owns the page
 * chrome. The full-chrome version stays the default for standalone route-level use.
 */
function ExplorerSkeleton({ contentOnly = false }: { contentOnly?: boolean }) {
  const { isDarkMode } = useTheme();

  const skeletonColor = isDarkMode ? '#2D3748' : '#E2E8F0';

  const body = (
    <>
      {/* the graph's own search box (top left) and filter / export actions (top right) */}
      <Box display="flex" justifyContent="space-between" marginBottom="15px">
        <Skeleton
          variant="rectangular"
          width="260px"
          height="34px"
          sx={{ borderRadius: '8px', backgroundColor: skeletonColor }}
        />
        <Box display="flex" gap="8px">
          {Array.from(new Array(2)).map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width="34px"
              height="34px"
              sx={{ borderRadius: '8px', backgroundColor: skeletonColor }}
            />
          ))}
        </Box>
      </Box>

      <Skeleton
        variant="rectangular"
        height="70vh"
        sx={{ borderRadius: '8px', backgroundColor: skeletonColor }}
      />
    </>
  );

  if (contentOnly) return body;

  return (
    <PageContent>
      <PageHeaderSkeleton isRegionFilter={false} />
      {body}
    </PageContent>
  );
}

export default ExplorerSkeleton;
